import { Controller } from "@hotwired/stimulus"

// FD-925: the Spotlight row on a team Gantt. A chip fades every bar and people label
// (the item targets) whose data-people lacks that person; clicking it again clears it, and
// another chip moves it. One person at a time, in the browser only: no request, no URL.
//
// The chosen person is kept on the controller, not in a DOM attribute: a Turbo morph (the
// page refresh after a peek edit) rewrites every class and aria-pressed from the server's
// markup and would wipe an attribute too. The controller isn't reconnected by a morph, so
// it puts the spotlight back once the morph lands.
//
// The fade is important (`opacity-20!`) because a finished bar already carries
// `opacity-60`, which Tailwind emits after `opacity-20` and would otherwise win.
const FADED = "opacity-20!"
const ACTIVE = ["border-brand", "text-on-surface"]

export default class extends Controller {
  static targets = ["chip", "item"]

  connect() {
    // Back and Forward render Turbo's cached snapshot, which keeps the fades and the pressed
    // chip, so pick the person up from it. A fresh page has no pressed chip.
    const pressed = this.chipTargets.find((chip) => chip.getAttribute("aria-pressed") === "true")
    this.personId = pressed ? pressed.dataset.personId : null
    this.apply()
    this.onMorph = () => this.apply()
    document.addEventListener("turbo:morph", this.onMorph)
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.onMorph)
  }

  toggle(event) {
    const id = event.currentTarget.dataset.personId
    this.personId = this.personId === id ? null : id
    this.apply()
  }

  apply() {
    // A morph can take the person off the chart; their chip goes, and so does the fade.
    if (this.personId && !this.chipTargets.some((chip) => chip.dataset.personId === this.personId)) {
      this.personId = null
    }
    this.chipTargets.forEach((chip) => {
      const on = chip.dataset.personId === this.personId
      chip.setAttribute("aria-pressed", String(on))
      ACTIVE.forEach((name) => chip.classList.toggle(name, on))
    })
    this.itemTargets.forEach((item) => {
      const people = (item.dataset.people || "").split(" ")
      item.classList.toggle(FADED, this.personId !== null && !people.includes(this.personId))
    })
  }
}
